export const environment = {
    production: false,
    uat: true,
    staging: false,
    baseUrl: "https://uat.api.raisingvoices.org/admin",
  };